import DepsService from 'services/dependencies';

const CONTEXT = 'documents';

export const fetchNewLabelStatus = () => {
  const url = DepsService.rest.documents.newLabel.url;
  const queryParams = {};
  const urlParams = {};

  return DepsService.restSrv.list(CONTEXT, url, queryParams, urlParams);
};

export const setNewLabelStatus = () => {
  const url = DepsService.rest.documents.newLabel.url;
  const queryParams = {};
  const urlParams = {};

  return DepsService.restSrv.create(CONTEXT, url, queryParams, urlParams);
};

export const prefetchDocument = (id) => {
  const url = DepsService.rest.documents.prefetch.url;
  const queryParams = {};
  const urlParams = { id };

  return DepsService.restSrv.get(CONTEXT, url, queryParams, urlParams);
};



// WEBPACK FOOTER //
// ./src/modules/documents/resources/documents.api.js